import React, { useState } from 'react';

const Switcher = ({ isChecked, setIsChecked }) => {
    return (
        <label className='flex items-center cursor-pointer select-none'>
            <div className='relative'>
                <input
                    type='checkbox'
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                    className='sr-only'
                />
                {/* Changer la couleur de fond du switch en fonction de isChecked */}
                <div
                    className={`block rounded-full w-14 h-8 transition-all duration-300 bg-gray-200`}
                ></div>
                <div
                    className={`top-1 left-1 absolute flex justify-center items-center  rounded-full w-6 h-6 transition-all duration-300 ${
                        isChecked ? 'translate-x-6  bg-orange-500' : 'translate-x-0 bg-white'
                    }`}
                >
                    <span className={`h-3 w-3 rounded-full ${isChecked ? 'bg-white' : 'bg-orange-500'} transition-all duration-300`}></span>
                </div>
            </div>
        </label>
    );
};

export default Switcher;
